<template>
  <v-text-field
    :rules="config.rules"
    :label="config.label"
    :data-cy="config.dataCy"
    v-model="inputVal[config.vModel]"
    dense
  ></v-text-field>
</template>
<script>
export default {
  props: ["config", "value"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
